import React from 'react'
import PropType from 'prop-types'
import ReferralDesktopLandingGuestUser from 'components/referral/landing/landing-desktop/guest-user'
import ReferralDesktopLandingNonLoyaltyUser from 'components/referral/landing/landing-desktop/non-loyalty-user'
import ReferralDesktopLandingLoyaltyUser from 'components/referral/landing/landing-desktop/loyalty-user'

const ReferralDesktopLanding = ({ isGuest, isLoyaltyMember, ref_type }) => {
  if (isGuest) {
    return <ReferralDesktopLandingGuestUser />
  }
  if (isLoyaltyMember) {
    return <ReferralDesktopLandingLoyaltyUser ref_type={ref_type} />
  }
  return <ReferralDesktopLandingNonLoyaltyUser ref_type={ref_type} />
}

ReferralDesktopLanding.propTypes = {
  isGuest: PropType.bool.isRequired,
  isLoyaltyMember: PropType.bool.isRequired,
  ref_type: PropType.string.isRequired,
}

export default ReferralDesktopLanding
